import {
  Box,
  Button,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Drawer,
  IconButton,
  Tooltip,
} from "@mui/material";

const DRAWER_SX = {
  zIndex: 1500,
  "& .MuiDrawer-paper": { width: 550 },
  "& .MuiSlide-enter, & .MuiSlide-exit": {
    transitionTimingFunction: "cubic-bezier(0.25, 0.8, 0.25, 1)",
    transitionDuration: "700ms",
  },
  "& .MuiSlide-entered": {
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "700ms",
  },
};

const FiltrosDrawer = ({
  open,
  onClose,
  onLimpar,
  onAplicar,
  titulo = "Filtros",
  children,
}) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    variant="temporary"
    SlideProps={{ timeout: 600 }}
    keepMounted
    sx={DRAWER_SX}
  >
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <CardHeader
        title={titulo}
        titleTypographyProps={{ variant: "h6", fontWeight: 700 }}
        action={
          <IconButton onClick={onClose}>
            <i className="ph-bold ph-x" style={{ fontSize: 20 }} />
          </IconButton>
        }
        sx={{ py: 2 }}
      />
      <Divider />
      <CardContent sx={{ flex: 1, overflowY: "auto", px: 3, py: 3 }}>
        <Box display="flex" flexDirection="column" gap={4}>
          {children}
        </Box>
      </CardContent>
      <Divider />
      <CardActions sx={{ justifyContent: "space-between", p: 2 }}>
        <Tooltip title="Restaurar filtros padrão" arrow>
          <Button
            variant="text"
            color="secondary"
            onClick={onLimpar}
            startIcon={<i className="ph-fill ph-broom" />}
          >
            Limpar
          </Button>
        </Tooltip>
        <Button
          variant="contained"
          color="primary"
          onClick={onAplicar}
          disableElevation
          startIcon={
            <i className="ph-fill ph-funnel" style={{ color: "white" }} />
          }
        >
          Aplicar Filtros
        </Button>
      </CardActions>
    </Box>
  </Drawer>
);

export default FiltrosDrawer;
